import { CombinedVueInstance } from 'vue/types/vue';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import Popup from '@/components/messageBox/popup';

@Component({
    name: 'CommonPopup',
    template: `<MyPopup v-model="value" class="qrcode-popup" position="center" :modal="true">
        <div class="qrcode-content">
            <div v-if="title" class="qrcode-title">{{title}}</div>
            <div v-if="desc" class="qrcode-desc" v-html="desc"></div>
            <img v-if="src" class="qrcode-img" :src="src" />
            <div v-if="desc2" class="qrcode-desc2" v-html="desc2"></div>

            <!-- 不再提示 -->
            <div v-if="neverDisplayVisible" class="qrcode-never-display gray-color">
                <MobileButton name="line-normal" class="btn-small" @click="onClickNeverDisplay">
                    <i class="icon" :class="{'gray-color': neverDisplay}">{{neverDisplay ? '&#xe604;' : '&#xe603;'}}</i>
                    不再提示
                </MobileButton>
            </div>
            <div v-if="actionText" class="action-btn-wrap">
                <MobileButton @click="actionCb" name="red-gradient" class="btn-normal btn-round action">{{actionText}}</MobileButton>
            </div>
            <i class="qrcode-close icon" @click="onClickClose">
                &#xe64b;
            </i>
        </div>
    </MyPopup>`,
})
export class CommonPopup extends Mixins(Popup) {
    @Prop({ type: String, default: '' }) public title!: string;
    @Prop({ type: String, default: '' }) public desc!: string;
    @Prop({ type: String, default: '' }) public src!: string;
    @Prop({ type: String, default: '' }) public desc2!: string;
    @Prop({ type: String, default: '' }) public actionText!: string;
    @Prop({ type: Boolean, default: false }) public neverDisplayVisible!: boolean;
    /** 操作回调 */
    @Prop({}) public actionCb!: any;
    /** 关闭回调 */
    @Prop({}) public closeCb!: any;

    /** 默认不勾选 */
    public neverDisplay: boolean = false;

    /**
     * 点击关闭
     */
    public onClickClose() {
        this.value = false;
        // 调用callback
        if (this.closeCb) {
            this.closeCb({ neverDisplay: this.neverDisplay });
        }
        // 重置neverDisplay
        this.neverDisplay = false;
    }
    public onClickNeverDisplay() {
        this.neverDisplay = !this.neverDisplay;
    }
}

export type CommonPopupComponent = CombinedVueInstance<CommonPopup, object, object, object, Record<keyof object, any>>;
